import styled from '@emotion/styled';
import React from 'react';
import ReactPlayer from 'react-player/lib/players/FilePlayer';

const PlayerWrapper = styled('div')({
    position: 'relative',
    paddingTop: '56.25%' /* Player ratio: 100 / (1280 / 720) */,
});

const StyledPlayer = styled(ReactPlayer)({
    position: 'absolute',
    top: 0,
    left: 0,
});

interface Props {
    title: string;
    src: string;
}

/**
 * @deprecated Use {@link components/VideoPlayer.tsx} in new code.
 */
export class LegacyVideoPlayer extends React.Component<Props> {
    public render(): JSX.Element {
        return (
            <PlayerWrapper>
                <StyledPlayer url={this.props.src} controls width="100%" height="100%" />
            </PlayerWrapper>
        );
    }
}
